import template from './index.pug'
import privacyPolicyText from '../privacy-policy-text'

export default Vue.extend({
  name: 'privacy-policiy-page-custom-cg',
  template: template(),
  components: {privacyPolicyText},
  created() {
    window.scrollTo(0, 0)
  }
})
